import { useTranslation } from "react-i18next";
import styles from "./Admin.module.scss";
import { useLocation, useNavigate } from "react-router";

const AdminHeader: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const location = useLocation()

  const handleClick = (page: string) => {
    navigate(`/admin/${page}`);
  };

  const getClassName = (page: string) => {
    const isSelected = location.pathname.indexOf(page) > -1;

   return `${styles.item} ${isSelected ? styles.itemSelected : ""}`;
  }

  return (
    <>
      <div className={styles.itemHeader}>{t("management")}</div>
      <div onClick={() => handleClick("teams")} className={getClassName("teams")}>
        {t("teams")}
      </div>
      <div onClick={() => handleClick("approvers")} className={getClassName("approvers")}>
        {t("approvers")}
      </div>      
    </>
  );
};

export default AdminHeader;
